// ================================================= /
// ======   GRAVITY FORMS JS  ====================== /
// ================================================= /

/* global jQuery */

import form from '../form';

/**
 * Class for handling Gravity Forms plugin extensions.
 */
class DispatchSkinGravityForms {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.formSelector = '.gform_wrapper';
		this.fieldSelector = '.gfield';

		this.eventNamespace = 'dispatchSkinGravityForms';
	}

	/**
	 * Initializes the class, sets up events.
	 */
	initialize() {

		if ( jQuery( this.formSelector ).length ) {

			this.eventDelegationParent = jQuery( '.site' );

			// Input focus
			this.eventDelegationParent.on(
				`focus.${this.eventNamespace}`,
				this.formSelector + ' :input:not([type="submit"])',
				( event ) => form.focusInput( jQuery( event.target ), this.formSelector, this.fieldSelector )
			);
			this.eventDelegationParent.on(
				`focusout.${this.eventNamespace}`,
				this.formSelector + ' :input',
				() => form.blurInput( jQuery( event.target ), this.formSelector, this.fieldSelector )
			);
			this.eventDelegationParent.on(
				`change.${this.eventNamespace}`,
				this.formSelector + ' select',
				() => form.blurInput( jQuery( event.target ), this.formSelector, this.fieldSelector )
			);
		}
	}

}

const gravityForms = new DispatchSkinGravityForms();
export default gravityForms;



// WEBPACK FOOTER //
// ./src/js/inc/plugins/gravity-forms.js